import api from '../api';

interface LoginParams {
  email: string;
  password: string;
}

interface RegisterParams {
  name: string;
  email: string;
  password: string;
  role?: string;
  department?: string;
  position?: string;
  phone?: string;
  avatar?: string;
}

interface AuthResponse {
  user: {
    id: string;
    email: string;
    name: string;
    role: string;
  };
  accessToken: string;
  refreshToken: string;
}

export const AuthService = {
  login: (data: LoginParams): Promise<AuthResponse> => {
    return api.post('/auth/login', data);
  },
  
  register: (data: RegisterParams): Promise<AuthResponse> => {
    return api.post('/auth/register', data);
  },
  
  logout: (): Promise<void> => {
    return api.post('/auth/logout');
  },
  
  refresh: (): Promise<AuthResponse> => {
    return api.post('/auth/refresh');
  },
  
  forgotPassword: (email: string): Promise<void> => {
    return api.post('/auth/forgot-password', { email });
  },
  
  resetPassword: (token: string, password: string): Promise<void> => {
    return api.post('/auth/reset-password', { token, password });
  },
  
  getCurrentUser: (): Promise<any> => {
    return api.get('/auth/me');
  }
}; 